import { Api } from '../base/Api';
import { Injectable } from '@angular/core';
import { Proposal } from 'src/app/models/Proposal';
@Injectable({
    providedIn: 'root'
})
export class ProposalApi extends Api<Proposal> {
}
